export default __webpack_public_path__ + "static/race-day-kids-vertical-b0233ccc6eada36813117d9f52207d82.png";